import { useEffect, useRef, useReducer } from "react";

import "./App.scss";
import { getApp, getAppRoutes, getEmptyRoutes } from "./common/utilities/routes/routes.util";
import { TivaDataWebSocketContainer } from "./common/containers/tiva-data/tiva-data-web-socket.container";
import { FirebaseAuthContainer } from "./common/containers/auth/firebase-auth-container.util";
import { ProvidersContainer } from "./common/containers/providers/providers.container";
import { ThemeContainer } from "./common/containers/theme/theme.container";
import { ToastProvider } from "./components/toast/toast.comp";

function App() {
    const { theme, devEnv, devMode } = ThemeContainer.useContainer();
    const AppRoutes = useRef<() => JSX.Element>(!devMode ? getAppRoutes() : getEmptyRoutes());
    const [, render] = useReducer(p => !p, false);

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
    }, [theme]);

    useEffect(() => {
        if (!devEnv) return;

        const app = getApp(devEnv);

        if (app) {
            AppRoutes.current = app.routes;
            render();
        }
    }, [devEnv]);

    return (
        <TivaDataWebSocketContainer.Provider>
            <FirebaseAuthContainer.Provider>
                <ProvidersContainer.Provider>
                    <ToastProvider>
                        <AppRoutes.current />
                    </ToastProvider>
                </ProvidersContainer.Provider>
            </FirebaseAuthContainer.Provider>
        </TivaDataWebSocketContainer.Provider>
    );
}

export default App;
